import React from 'react';

const DialogControlContext = React.createContext(null);

export const useDialogControl = () => React.useContext(DialogControlContext);

export default DialogControlContext;
